export const getPricingTitleInternal = () => {
    return "Jira Pricing Page";
};
